<template>
  <div class="space-y-2 py-4">
    <div class="flex space-x-2 items-start">
      <BaseButton v-if="!show" primary outline @click="show = true"> Add Email Address </BaseButton>
      <div v-else class="w-64">
        <EmailAddressForm
          :save-action="createEmailAddress"
          force-actions-visibility
          @canceled="show = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { contactEmailAddressesClient } from '@/api/clients';
import EmailAddressForm from './EmailAddressForm.vue';

export default {
  components: {
    EmailAddressForm,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
    onCreated: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      creating: false,
      show: false,
    };
  },
  methods: {
    async createEmailAddress(formData) {
      if (this.creating) {
        return Promise.resolve();
      }

      try {
        this.creating = true;

        await contactEmailAddressesClient.store(this.contactId, formData);

        this.show = false;

        await this.onCreated();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.creating = false;
      }
    },
  },
};
</script>
